import templateUrl from './payment-methods-add.html';

export const paymentMethodsAddComponent = {
    bindings: {
        resolve: '<',
        close: '&'
    },

    templateUrl,

    controller: class PaymentMethodsAddComponent {
        constructor(PaymentMethodsService, toastr) {
            'ngInject';

            this.toastr = toastr;
            this.paymentMethodsService = PaymentMethodsService;
        }

        $onInit() {
            this.details = {
                paymentMethod: ''
            };
            this.disableSaveButton = false;
        }

        /*******************
         * Public Methods
         ***************/

        onSubmit() {
            this.disableSaveButton = true;
            this.paymentMethodsService.addPaymentMethod(this.details)
                .then(_ => {
                    this.toastr.success('Payment Method added successfully');
                    this.disableSaveButton = false;
                    this.close();
                })
                .then(_ => this.resolve.details.reloadList())
                .catch(err => {
                    this.toastr.error(err);
                    this.disableSaveButton = false;
                });
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/components/payment-methods/payment-methods-add/payment-methods-add.component.js